import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MySelect from '../../../../UI/form/MySelect'
import { setSupplyBillsFiltersPaymentStatus, setSupplyBillsFiltersStatus } from '../../../../../store/supplyBillSlice'
import PaymentStatusSelect from '../../../supplyBill/view/payments/forms/changeStatus/fields/PaymentStatusSelect'

const SupplyBillsFilterPaymentStatus = () => {

    const status = useSelector(state => state.supplyBill.supplyBills.filters.paymentStatus)
	const dispatch = useDispatch()

  	const [value, setValue] = useState(status)
  	// const [validSelect, setValidSelect] = useState(false)
	// const [options, setOptions] = useState([
	// 	{
	// 		id: 'work',
	// 		name: 'В роботі'
	// 	},
	// 	{
	// 		id: 'cancel',
	// 		name: 'Скасовані'
	// 	},
	// 	{
	// 		id: 'all',
	// 		name: 'Всі'
	// 	},
	// ])

  return (
	<PaymentStatusSelect 
		required={false}
		setValidate={e => {}}
		setValueForm={e => {
			setValue(e)
			dispatch(setSupplyBillsFiltersPaymentStatus(e))
		}}
		// optionDefault={{
		// 	value: '',
		// 	name: 'Всі'
		// }}
		optionsDefault={[
			{
				value: '',
				name: 'Всі'
			},
			{
				value: 'create',
				name: 'Створено'
			}
		]}
		forciblyValue={value}
	/>
    // <MySelect
    //     value={value}
    //     label="Статус оплати"
    //     labelId="select__statusFilter-label"
    //     id='select__statusFilter'
    //     onChange = {e => {
    //         setValue(e)
	// 		dispatch(setSupplyBillsFiltersPaymentStatus(e))
	// 		// setEvent({...event, categoryId: e})
	// 	}}
    //     nameField='Статус оплати'
    //     // sx={{width: '200px'}}
    //     options={
	// 		options && options.length > 0 ? 
	// 			options.map(option => {
    //         		return {id: option.id, name: option.name}
	// 			})
	// 		: []	
	// 	}
    //     // options={[]}
    // />
  )
}

export default SupplyBillsFilterPaymentStatus